<template>
  <div class="modal" v-if="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main new-modal">
      <!-- カラー設定モーダル -->
      <dd-color-material-list-modal
        ref="ColorMaterialListModalRef"
        :fileData="fileData"
        @changeColorStyleGrp="changeColorStyleGrp"
      />
      <dd-custom-color-list-modal
        ref="CustomColorListModalRef"
        :fileData="fileData"
        @changeColorIdGrp="changeColorIdGrp"
      />
      <div class="title-area" id="modal-moving">
        <h2>カラー設定</h2>
      </div>
      <div class="data-area">
        <div class="contents">
          <section class="tab-detail-color-style">
            <div class="bs-checkbox" v-if="isOlis">
              <label><input type="checkbox" v-model="isOwnColor">選択したユニットのカラー設定</label>
            </div>
            <div v-else>
              <label>選択したユニットのカラー設定</label>
            </div>
            <ul>
              <li>
                <span class="label">カラースタイル名</span>
                <div class="div-color-style">{{colorStyleConfig.colorStyleConfigName}}</div>
                <span class="label-color-style">補足情報</span>
              </li>
              <li v-if="colorStyleNameList[csKey]" v-for="(csValue, csKey) in colorStyleNameList" :key="csKey">
                <section v-if="isOlis">
                  <span class="label">{{colorStyleNameList[csKey]}}</span>
                  <div>
                    <button class="main_btn" :class="{img_disable: !isOwnColor}" @click="showCMListModal(csKey)">変更</button>
                    {{ colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp[csKey]).colorMaterialName }}
                  </div>
                  <input class="sm-input" :disabled="!isOwnColor" v-model="colorStyleGrpStr[csKey]">
                  <div class="div-custom">
                    <button class="main_btn" v-if="isOwnColor && colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp[csKey]).colorMaterialCustomFlg"
                    @click="showCustomListModal(csKey)">カスタム</button>
                  </div>
                </section>
                <section v-else>
                  <span class="label">{{colorStyleNameList[csKey]}}</span>
                  <div>
                    <button class="main_btn" :class="{img_disable: !isColor[csKey]}" @click="showCMListModal(csKey)">変更</button>
                    {{ colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp[csKey]).colorMaterialName }}
                  </div>
                  <input class="sm-input" :disabled="!isColor[csKey]" v-model="colorStyleGrpStr[csKey]">
                  <div class="div-custom">
                    <button class="main_btn" v-if="isColor[csKey] && colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp[csKey]).colorMaterialCustomFlg"
                    @click="showCustomListModal(csKey)">カスタム</button>
                  </div>
                </section>
              </li>
            </ul>
          </section>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['colorStyleDefault'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['colorStyleDefaultStr'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['colorStyleGroup1Str'] }}</p>
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['colorStyleGroup2Str'] }}</p>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="editColor">設定</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import ColorMaterialListModal from '../../planning/modal/ColorMaterialListModal'
import CustomColorListModal from '../../planning/modal/CustomColorListModal'
import {OBJECT_DTL_TYPE, PLANNING_TYPE} from '../../../constants/Type'

export default {
  name: 'SetColorModal',
  components: {
    'dd-color-material-list-modal': ColorMaterialListModal,
    'dd-custom-color-list-modal': CustomColorListModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    /** 構成ツリーのフォーカス空間 */
    focusedMenuSpace: Object,
    /** 自身（持っていなければ直近の親）のカラースタイル */
    ownColorStyle: Object,
    /** シリーズ */
    series: Object
  },
  data () {
    return {
      modalShown: false,
      /** 自身のカラースタイルか（自身のカラースタイルとするか） */
      isOwnColor: false,
      isColor: {0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false},
      colorStyleGrp: {0: '', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      colorStyleGrpStr: {0: '', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      colorStyleGrpColor: {0: '', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      /** カラー素材一覧 */
      colorMaterialList: [],
      /** カラースタイル設定詳細マスター */
      colorStyleConfigDtl: [],
      /** カラースタイル設定マスター */
      colorStyleConfig: {},
      /** カラースタイル名を管理する配列 */
      colorStyleNameList: {},
      /** カラーリストタイプを管理する配列 */
      colorStyleTypeList: {},
      message: '',
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      this.validateErrorMessages = {}
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    /** 自身（持っていなければ直近の親）のカラースタイル監視 */
    ownColorStyle: function () {
      this.setColorStyle()
    },
    /** シリーズ監視 */
    series: function () {
      this.getColorStyleConfig(this.series.seriesColorStyleConfigId)
    }
  },
  computed: {
    isOlis: function () {
      let user = AppUtil.getUserInfo()
      return user.corpId === 1070
    }
  },
  methods: {
    /** カラーマテリアルモーダルの表示 */
    showCMListModal: function (csKey) {
      let obj = this.fileData.objectDataModelList.find(obj => obj.spaceId === this.editCtrlSpaces[0].id)
      let unit = this.editCtrlSpaces[0]
      if (unit.planningType === PLANNING_TYPE.UNIT_DRAWER) {
        let unitComp = unit.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_COMP_DOOR)
        console.log(unitComp)
        if (unitComp) {
          // 前板
          let frontSpace = unitComp.childrenSpaceModel.find(child => child.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_TOP_DRAWER.code)
          if (frontSpace) {
            obj = this.fileData.objectDataModelList.find(obj => obj.spaceId === frontSpace.id)
          }
        }
      }
      let factoryId = obj.objFactoryId
      let colorList = []
      if (factoryId === undefined || factoryId === 0) {
        colorList = this.colorMaterialList.filter(e => e.colorMaterialType === this.colorStyleTypeList[csKey])
      } else {
        colorList = this.colorMaterialList.filter(e => e.colorMaterialType === this.colorStyleTypeList[csKey] && this.isFactoryCheck(e.colorMaterialFactoryId, factoryId))
      }
      this.$refs.ColorMaterialListModalRef.showModal(
        this.colorStyleGrp[csKey],
        colorList,
        false,
        csKey)
    },
    isFactoryCheck: function (colorMaterialFactoryId, factoryId) {
      if (colorMaterialFactoryId === 0) return true
      if (colorMaterialFactoryId === null) return true
      if (colorMaterialFactoryId === factoryId) return true
      return false
    },
    /** カラー画像の表示 */
    showCustomListModal: function (csKey) {
      this.$refs.CustomColorListModalRef.showModal(
        this.colorStyleGrp[csKey],
        this.colorStyleGrpColor[csKey],
        this.colorMaterialList.filter(e => e.colorMaterialType === this.colorStyleTypeList[csKey]),
        false,
        csKey)
    },
    /** デフォルトのカラースタイルの変更 */
    changeColorStyleGrp: function (colorStyleGrp, csKey) {
      this.colorStyleGrp[csKey] = colorStyleGrp
      const customFlg = this.colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp).colorMaterialCustomFlg
      if (!customFlg) {
        this.colorStyleGrpColor[csKey] = null
      }
    },
    /** 画像の変更 */
    changeColorIdGrp: function (id, csKey) {
      this.colorStyleGrpColor[csKey] = id
    },
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
      this.selectKey()
    },
    /** キャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** 送信 */
    editColor: function () {
      let payload = {
        spaceId: this.focusedMenuSpace != null ? this.focusedMenuSpace.id : this.editCtrlSpaces[0].id,
        colorStyleDefault: this.colorStyleGrp[0],
        colorStyleGroup1: this.colorStyleGrp[1],
        colorStyleGroup2: this.colorStyleGrp[2],
        colorStyleGroup3: this.colorStyleGrp[3],
        colorStyleGroup4: this.colorStyleGrp[4],
        colorStyleGroup5: this.colorStyleGrp[5],
        colorStyleGroup6: this.colorStyleGrp[6],
        colorStyleGroup7: this.colorStyleGrp[7],
        colorStyleGroup8: this.colorStyleGrp[8],
        colorStyleGroup9: this.colorStyleGrp[9],
        colorStyleGroup10: this.colorStyleGrp[10],
        colorStyleDefaultStr: this.colorStyleGrpStr[0],
        colorStyleGroup1Str: this.colorStyleGrpStr[1],
        colorStyleGroup2Str: this.colorStyleGrpStr[2],
        colorStyleGroup3Str: this.colorStyleGrpStr[3],
        colorStyleGroup4Str: this.colorStyleGrpStr[4],
        colorStyleGroup5Str: this.colorStyleGrpStr[5],
        colorStyleGroup6Str: this.colorStyleGrpStr[6],
        colorStyleGroup7Str: this.colorStyleGrpStr[7],
        colorStyleGroup8Str: this.colorStyleGrpStr[8],
        colorStyleGroup9Str: this.colorStyleGrpStr[9],
        colorStyleGroup10Str: this.colorStyleGrpStr[10],
        colorStyleDefaultColor: this.colorStyleGrpColor[0],
        colorStyleGroup1Color: this.colorStyleGrpColor[1],
        colorStyleGroup2Color: this.colorStyleGrpColor[2],
        colorStyleGroup3Color: this.colorStyleGrpColor[3],
        colorStyleGroup4Color: this.colorStyleGrpColor[4],
        colorStyleGroup5Color: this.colorStyleGrpColor[5],
        colorStyleGroup6Color: this.colorStyleGrpColor[6],
        colorStyleGroup7Color: this.colorStyleGrpColor[7],
        colorStyleGroup8Color: this.colorStyleGrpColor[8],
        colorStyleGroup9Color: this.colorStyleGrpColor[9],
        colorStyleGroup10Color: this.colorStyleGrpColor[10],
        isOwnColor: this.isOlis ? this.isOwnColor : true,
        editColorSpaceList: this.editCtrlSpaces.map(space => space.id)
      }
      axios.post(API_URL.PLANNING + '/edit-own-color-style', payload
      ).then(response => {
        if (response.data.errorMessage) {
          // エラーメッセージ表示
          this.$emit('handleErrorMessage', response)
        } else {
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          AppUtil.showModal({
            messages: ['カラーを変更しました。']
          })
          this.$emit('setResponseData', response)
        }
      }).catch(error => {
        // バリデーションエラー
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    /** 自身（持っていなければ直近の親）のカラースタイルを画面に反映 */
    setColorStyle: function () {
      if (this.fileData.colorStyleDataModelList && this.fileData.colorStyleDataModelList.length > 0 && this.ownColorStyle) {
        this.isOwnColor = this.ownColorStyle.isOwnColor
        this.colorStyleGrp[0] = this.ownColorStyle.colorStyleDefault
        this.colorStyleGrp[1] = this.ownColorStyle.colorStyleGroup1
        this.colorStyleGrp[2] = this.ownColorStyle.colorStyleGroup2
        this.colorStyleGrp[3] = this.ownColorStyle.colorStyleGroup3
        this.colorStyleGrp[4] = this.ownColorStyle.colorStyleGroup4
        this.colorStyleGrp[5] = this.ownColorStyle.colorStyleGroup5
        this.colorStyleGrp[6] = this.ownColorStyle.colorStyleGroup6
        this.colorStyleGrp[7] = this.ownColorStyle.colorStyleGroup7
        this.colorStyleGrp[8] = this.ownColorStyle.colorStyleGroup8
        this.colorStyleGrp[9] = this.ownColorStyle.colorStyleGroup9
        this.colorStyleGrp[10] = this.ownColorStyle.colorStyleGroup10
        this.colorStyleGrpStr[0] = this.ownColorStyle.colorStyleDefaultStr
        this.colorStyleGrpStr[1] = this.ownColorStyle.colorStyleGroup1Str
        this.colorStyleGrpStr[2] = this.ownColorStyle.colorStyleGroup2Str
        this.colorStyleGrpStr[3] = this.ownColorStyle.colorStyleGroup3Str
        this.colorStyleGrpStr[4] = this.ownColorStyle.colorStyleGroup4Str
        this.colorStyleGrpStr[5] = this.ownColorStyle.colorStyleGroup5Str
        this.colorStyleGrpStr[6] = this.ownColorStyle.colorStyleGroup6Str
        this.colorStyleGrpStr[7] = this.ownColorStyle.colorStyleGroup7Str
        this.colorStyleGrpStr[8] = this.ownColorStyle.colorStyleGroup8Str
        this.colorStyleGrpStr[9] = this.ownColorStyle.colorStyleGroup9Str
        this.colorStyleGrpStr[10] = this.ownColorStyle.colorStyleGroup10Str
        this.colorStyleGrpColor[0] = this.ownColorStyle.colorStyleDefaultColor
        this.colorStyleGrpColor[1] = this.ownColorStyle.colorStyleGroup1Color
        this.colorStyleGrpColor[2] = this.ownColorStyle.colorStyleGroup2Color
        this.colorStyleGrpColor[3] = this.ownColorStyle.colorStyleGroup3Color
        this.colorStyleGrpColor[4] = this.ownColorStyle.colorStyleGroup4Color
        this.colorStyleGrpColor[5] = this.ownColorStyle.colorStyleGroup5Color
        this.colorStyleGrpColor[6] = this.ownColorStyle.colorStyleGroup6Color
        this.colorStyleGrpColor[7] = this.ownColorStyle.colorStyleGroup7Color
        this.colorStyleGrpColor[8] = this.ownColorStyle.colorStyleGroup8Color
        this.colorStyleGrpColor[9] = this.ownColorStyle.colorStyleGroup9Color
        this.colorStyleGrpColor[10] = this.ownColorStyle.colorStyleGroup10Color
      } else {
        // 親のスタイルもない場合
        this.isOwnColor = false
        this.colorStyleGrp = {
          0: this.colorStyleTypeList[0] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[0]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[0]).colorMaterialId : '',
          1: this.colorStyleTypeList[1] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[1]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[1]).colorMaterialId : '',
          2: this.colorStyleTypeList[2] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[2]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[2]).colorMaterialId : '',
          3: this.colorStyleTypeList[3] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[3]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[3]).colorMaterialId : '',
          4: this.colorStyleTypeList[4] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[4]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[4]).colorMaterialId : '',
          5: this.colorStyleTypeList[5] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[5]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[5]).colorMaterialId : '',
          6: this.colorStyleTypeList[6] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[6]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[6]).colorMaterialId : '',
          7: this.colorStyleTypeList[7] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[7]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[7]).colorMaterialId : '',
          8: this.colorStyleTypeList[8] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[8]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[8]).colorMaterialId : '',
          9: this.colorStyleTypeList[9] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[9]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[9]).colorMaterialId : '',
          10: this.colorStyleTypeList[10] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[10]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[10]).colorMaterialId : ''
        }
      }
    },
    /** カラースタイル設定取得 */
    getColorStyleConfig: function (id) {
      axios.get(API_URL.PLANNING + '/color-style-conf/' + id
      ).then(response => {
        this.colorStyleConfig = response.data.data
        // リスト表示しやすいようにデータを整形する
        this.colorStyleNameList = {
          0: this.colorStyleConfig.colorStyleConfigDefaultComment,
          1: this.colorStyleConfig.colorStyleConfigGroup1Comment,
          2: this.colorStyleConfig.colorStyleConfigGroup2Comment,
          3: this.colorStyleConfig.colorStyleConfigGroup3Comment,
          4: this.colorStyleConfig.colorStyleConfigGroup4Comment,
          5: this.colorStyleConfig.colorStyleConfigGroup5Comment,
          6: this.colorStyleConfig.colorStyleConfigGroup6Comment,
          7: this.colorStyleConfig.colorStyleConfigGroup7Comment,
          8: this.colorStyleConfig.colorStyleConfigGroup8Comment,
          9: this.colorStyleConfig.colorStyleConfigGroup9Comment,
          10: this.colorStyleConfig.colorStyleConfigGroup10Comment
        }
        // プルダウン表示しやすいようにデータを整形する
        this.colorStyleTypeList = {
          0: this.colorStyleConfig.colorStyleConfigDefaultType,
          1: this.colorStyleConfig.colorStyleConfigGroup1Type,
          2: this.colorStyleConfig.colorStyleConfigGroup2Type,
          3: this.colorStyleConfig.colorStyleConfigGroup3Type,
          4: this.colorStyleConfig.colorStyleConfigGroup4Type,
          5: this.colorStyleConfig.colorStyleConfigGroup5Type,
          6: this.colorStyleConfig.colorStyleConfigGroup6Type,
          7: this.colorStyleConfig.colorStyleConfigGroup7Type,
          8: this.colorStyleConfig.colorStyleConfigGroup8Type,
          9: this.colorStyleConfig.colorStyleConfigGroup9Type,
          10: this.colorStyleConfig.colorStyleConfigGroup10Type
        }
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** カラー素材一覧取得 */
    getColorMaterialList: function () {
      axios.get(API_URL.PLANNING + '/color-material'
      ).then(response => {
        this.colorMaterialList = response.data.data
      }).catch(error => {
        Api.handleError(error)
      })
    },
    selectKey: function () {
      let unitList = this.editCtrlSpaces.filter(space => ![PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_DRAWER].includes(space.planningType))
      let skList = unitList.filter(space => OBJECT_DTL_TYPE.UNIT_COUNTER.code !== space.spaceObjectDtlType)
      if (skList.length > 0) {
        this.isColor[0] = true
      } else {
        this.isColor[0] = false
      }
      let isDoor = this.editCtrlSpaces.find(space => [PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_DRAWER].includes(space.planningType))
      let surfaceList = this.editCtrlSpaces.filter(space => PLANNING_TYPE.UNIT_SURFACE === space.planningType)
      let isSurface = surfaceList.find(space => OBJECT_DTL_TYPE.UNIT_COUNTER.code !== space.spaceObjectDtlType)
      if (isSurface) isDoor = true

      if (isDoor) {
        this.isColor[1] = true
      } else {
        this.isColor[1] = false
      }
      let isCounter = this.editCtrlSpaces.find(space => OBJECT_DTL_TYPE.UNIT_COUNTER.code === space.spaceObjectDtlType)
      if (isCounter) {
        this.isColor[2] = true
      } else {
        this.isColor[2] = false
      }
      let isMulti = this.editCtrlSpaces.find(space => [PLANNING_TYPE.COMBINE, PLANNING_TYPE.SETPLAN].includes(space.planningType))
      if (isMulti) {
        this.isColor[0] = true
        this.isColor[1] = true
        this.isColor[2] = true
      }
    }
  },
  created: function () {
    this.getColorMaterialList()
  }
}
</script>
<style lang="scss" scoped>
select{
  width: 267px;
}
.data-area {
  min-height: 200px;
  margin: 20px auto;
  -webkit-box-shadow: 0 0 10px rgba(102, 102, 102, 0.1);
  box-shadow: 0 0 10px rgba(102, 102, 102, 0.1);
  .contents{
    margin: 20px auto;
    .tab-detail{
      text-align: center;
      min-height: 500px;
      padding-bottom: 20px;
    }
    .tab-detail-color-style{
        text-align: left;
        min-height: 500px;
        padding-bottom: 20px;
        padding-left: 20px;
        .label-color-style{
          min-width: 195px;
          display: inline-block;
          text-align: center;
        }
        .div-color-style{
          width: 247px;
          display: inline-block;
        }
    }
    li {
      margin: 10px auto;
    }
    .label{
      min-width: 135px;
      display: inline-block;
      text-align: left;
    }
    .bs-checkbox{
      width: 231px;
    }
    div{
      width: 255px;
      display: inline-block;
      padding: 10px;
      text-align: left;
    }
    .div-custom {
      width: 75px;
    }
  }
}
.new-modal{
  max-height: 100%;
  max-width: 750px;
  min-width: 660px;
  padding-left: 40px;
  padding-right: 40px;
}
input.sm{
  width: 60px
}
.error_message{
  margin: 5px auto;
  text-align: left;
  padding-left: 123px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetColorModal.vue